// ---------------------------------------------------------------------------
// Escape helpers
// ---------------------------------------------------------------------------

/**
 * Escape a string for inline insertion into an existing JSON string literal
 * that lives inside an HTML script (Next.js __next_f.push payload).
 */
export const jsonStringEscape = (s) =>
  s
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\n/g, ' ')
    .replace(/\r/g, ' ')
    .replace(/\t/g, ' ');

/**
 * Escape a value being dropped into a `content="..."` HTML attribute.
 * Only escapes characters that break attribute parsing.
 */
export const htmlAttrEscape = (s) =>
  s
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

/**
 * Sanitise a value for insertion into HTML inner text / element content.
 * We only escape the bare minimum so the visible text is clean and readable.
 * Quotes are left alone — they are safe inside element content.
 */
export const htmlTextEscape = (s) =>
  s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');